import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SliderPanel } from 'wix-rich-content-ui-components';
import { BaseToolbarButton } from '../baseToolbarButton.js';
import { BUTTONS } from './keys.js';
import 'react-dom';
import 'classnames';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var createSliderPanelButton = ({ Icon, tooltipTextKey, getValue, onChange }) => {
  var _a;
  return _a = class extends Component {
    render() {
      const Content = (props) => /* @__PURE__ */ React.createElement(SliderPanel, __spreadValues(__spreadValues({ getValue, onChange }, this.props), props));
      return /* @__PURE__ */ React.createElement(
        BaseToolbarButton,
        __spreadProps(__spreadValues({
          icon: Icon,
          panelContent: Content,
          tooltipTextKey
        }, this.props), {
          type: BUTTONS.PANEL
        })
      );
    }
  }, __publicField(_a, "propTypes", {
    min: PropTypes.number,
    max: PropTypes.number,
    inputMin: PropTypes.number,
    inputMax: PropTypes.number,
    mapStoreDataToPanelProps: PropTypes.func,
    getEditorBounds: PropTypes.func,
    helpers: PropTypes.object,
    pluginType: PropTypes.string
  }), _a;
};

export { createSliderPanelButton as default };
//# sourceMappingURL=createSliderPanelButton.js.map
